<div class="team-selection">
  @if (teams && teams.length > 0) {
    <div class="team-selection__content">
      <img id="teamSelectionLogo" [src]="'logo_small.png' | tenantSpecificAsset" alt="Logo small"/>
      <p id="teamSelectionTitle" class="headline-medium">{{ 'teamSelection.title' | translate }}</p>
      <p id="teamSelectionText" class="body-large">{{ 'teamSelection.description' | translate }}</p>
      <div class="team-selection__grid">
        @for (team of teams; track team) {
          <app-team-card [team]="team" (selectTeam)="changeTeam($event)"></app-team-card>
        }
      </div>
    </div>
  }
  @if (!teams || teams.length < 1) {
    <div class="team-selection__content">
      <p id="noTeamTitle" class="headline-medium">{{ 'teamSelection.noTeams.title' | translate }}</p>
      <img id="noTeamLogo" [src]="'logo_small.png' | tenantSpecificAsset" alt="Logo"/>
    </div>
  }
</div>
